import { SimpleText } from "components/common/text/SimpleText";
import styled from "styled-components";

export default styled(SimpleText)`
  color: ${({ theme }) => theme.color.foreground.tertiary};
`;
